import React, { useEffect, useState, Suspense } from "react"
import { Routes, Route } from "react-router-dom"

// Global layout
import Navbar from "./components/Navbar.jsx"
import Footer from "./components/Footer.jsx"
import PrivateRoute from "./components/PrivateRoute.jsx"
import ScrollToTop from "./components/ScrollToTop.jsx"

// Landing pages (data-driven)
import LandingPage from "./pages/landing/LandingPage.jsx"

// Pages
import Home from "./pages/Home.jsx"
import WebDesignAdelaide from "./pages/WebDesignAdelaide.jsx"
import Dashboard from "./pages/Dashboard.jsx"
import ThankYou from "./pages/ThankYou.jsx"
import HealthCheck from "./pages/health-check/HealthCheck.jsx"
import PrivateHealthCheck from "./pages/health-check/PrivateHealthCheck.jsx"
import PrintTest from "./pages/PrintTest.jsx"
import Quote from "./pages/Quote.jsx"
import PrivateLogin from "./pages/PrivateLogin.jsx"
import FluffySideClubQuote from "./pages/FluffySideClubQuote.jsx"
import Blog from "./pages/Blog.jsx"
import Post from "./pages/Post.jsx"
import CoffeeQuote from "./pages/CoffeeQuote.jsx"
import JmdsProposalPage from "./pages/proposals/Jmds.jsx"
import ScopeBrief from "./pages/ScopeBrief.jsx"
import Logos from "./pages/Logos.jsx"
import Terms from "./pages/Terms.jsx"
import GoogleAds from "./pages/GoogleAds.jsx"
import Services from "./pages/Services.jsx"
import ServicePage from "./pages/services/ServicePage.jsx"
import Industries from "./pages/Industries.jsx"
import About from "./pages/About.jsx"

// Sections
import Contact from "./components/Contact.jsx"
import WhyWebsites from "./components/Whywebsites.jsx"
import Portfolio from "./components/Portfolio.jsx"

// Landing pages (single-file special)
import WebsiteLanding from "./pages/WebsiteLanding.jsx"
import LandingIndex from "./pages/landing/LandingIndex.jsx"

export default function App() {
  const [Popup, setPopup] = useState(null)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)

    if (params.get("nooffer") === "1") {
      return
    }

    const timer = setTimeout(() => {
      import("./components/SpecialOfferPopup.jsx").then(module => {
        setPopup(() => module.default)
      })
    }, 8000)

    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <Routes>
          <Route path="/" element={<Home />} />

          <Route
            path="/web-design-adelaide"
            element={<WebDesignAdelaide />}
          />

          <Route
            path="/website-landing"
            element={<WebsiteLanding />}
          />

          <Route
            path="/lp-index-72a9"
            element={
              <PrivateRoute>
                <LandingIndex />
              </PrivateRoute>
            }
          />

          <Route
            path="/logos-7f3k"
            element={
              <PrivateRoute>
                <Logos />
              </PrivateRoute>
            }
          />

          <Route
            path="/dashboard"
            element={<Dashboard />}
          />

          <Route
            path="/terms"
            element={<Terms />}
          />

          <Route
            path="/contact"
            element={<Contact />}
          />

          <Route
            path="/whywebsites"
            element={<WhyWebsites />}
          />

          <Route
            path="/portfolio"
            element={<Portfolio />}
          />

          <Route
            path="/website-health-check"
            element={<HealthCheck />}
          />

          <Route
            path="/print-test"
            element={<PrintTest />}
          />

          <Route
            path="/fluffysideclubquote"
            element={
              <PrivateRoute>
                <FluffySideClubQuote />
              </PrivateRoute>
            }
          />

          <Route
            path="/blog"
            element={<Blog />}
          />

          <Route
            path="/blog/:slug"
            element={<Post />}
          />

          <Route
            path="/private/login"
            element={<PrivateLogin />}
          />

          <Route
            path="/scope-brief"
            element={<ScopeBrief />}
          />

          <Route
            path="/google-ads-adelaide"
            element={<GoogleAds />}
          />

          <Route
            path="/thank-you"
            element={<ThankYou />}
          />

          <Route
            path="/private-health-check"
            element={
              <PrivateRoute>
                <PrivateHealthCheck />
              </PrivateRoute>
            }
          />

          <Route
            path="/quote/:slug"
            element={
              <PrivateRoute>
                <Quote />
              </PrivateRoute>
            }
          />

          <Route
            path="/private/quote/:slug"
            element={
              <PrivateRoute>
                <Quote />
              </PrivateRoute>
            }
          />

          <Route
            path="/private/coffeejourneyquote"
            element={
              <PrivateRoute>
                <CoffeeQuote />
              </PrivateRoute>
            }
          />

          <Route
            path="/proposal/jmds"
            element={
              <PrivateRoute>
                <JmdsProposalPage />
              </PrivateRoute>
            }
          />

          {/* Repositioning: services, industries and about (Stage 4) */}
          <Route
            path="/services"
            element={<Services />}
          />

          <Route
            path="/digital-strategy"
            element={<ServicePage serviceKey="digital-strategy" />}
          />

          <Route
            path="/seo-adelaide"
            element={<ServicePage serviceKey="seo" />}
          />

          <Route
            path="/business-integrations"
            element={<ServicePage serviceKey="business-integrations" />}
          />

          <Route
            path="/digital-support"
            element={<ServicePage serviceKey="digital-support" />}
          />

          <Route
            path="/industries"
            element={<Industries />}
          />

          <Route
            path="/about"
            element={<About />}
          />

          <Route
            path="*"
            element={<LandingPage />}
          />
        </Routes>
      </main>

      <Footer />

      {Popup && (
        <Suspense fallback={null}>
          <Popup autoloadDelayMs={0} />
        </Suspense>
      )}
    </>
  )
}